module.exports = __webpack_public_path__ + "img/_DSC7443.8d02432d.jpg";